export const dbConfig = {
  version: 1,
  tableName: 'pickupEvidence'
};

export const messages = {
  noEvidenceError: 'Erro ao enviar foto. Por favor tire outra.'
};
